import IDream from "motw_core/Entity/IDream";
import * as React from "react";
import Render from "../../../Shared/Render";
import { UnsolvableProblemIcon } from "./UnsolvableProblemIcon/UnsolvableProblemIcon";
import { DreamAttributeIconBasic } from "./DreamAttributeIconBasic";

export function DreamAttributeIcons({
    dream,
    showAllIcons,
}: {
    dream: IDream;
    showAllIcons: boolean;
}) {
    const { attributes } = dream;

    return (
        <span>
            <Render id="AttributeIcon" when={attributes.length === 1}>
                <DreamAttributeIconBasic
                    attribute={attributes[0]}
                    dream={dream}
                />
            </Render>
            <Render
                id="AttributeIcons"
                when={showAllIcons && attributes.length > 1}
            >
                {attributes.map((attribute, index) => (
                    <DreamAttributeIconBasic
                        attribute={attribute}
                        key={index}
                        dream={dream}
                    />
                ))}
            </Render>
        </span>
    );
}

export default DreamAttributeIcons;
